import React from 'react';
import { fetchMe, getCachedCapabilities } from '../lib/meClient';

export function useCapabilities() {
  const [capabilities, setCapabilities] = React.useState<Record<string, boolean> | null>(() => getCachedCapabilities());
  const [loaded, setLoaded] = React.useState(() => getCachedCapabilities() !== null);

  React.useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (cancelled) return;
        setCapabilities((me?.capabilities as Record<string, boolean> | undefined) ?? {});
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setCapabilities((prev) => prev ?? {});
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const can = React.useCallback(
    (key: string) => Boolean(capabilities && capabilities[key] === true),
    [capabilities],
  );

  return { capabilities, loaded, can };
}
